export default __webpack_public_path__ + "static/media/TTAAgencyWelcomeTextLogo.98a3180e.svg";